// AI内容标识公告相关工具函数

const AI_NOTICE_STORAGE_KEY = "ai_content_notice_shown";

/**
 * 检查是否需要显示AI内容标识公告
 * 在9月1日和9月5日第一次打开时显示
 */
export const shouldShowAINotice = (): boolean => {
  try {
    const today = new Date();
    const currentMonth = today.getMonth() + 1; // getMonth() 返回 0-11
    const currentDate = today.getDate();
    const currentYear = today.getFullYear();

    if (currentYear !== 2025) {
      return false;
    }

    // 调试信息
    console.log("[AI Notice] Date check:", {
      currentDate: `${currentYear}-${currentMonth}-${currentDate}`,
    });

    // 只在9月份检查
    if (currentMonth !== 9) {
      return false;
    }

    // 只在9月1日和9月5日检查
    if (currentDate !== 1 && currentDate !== 5) {
      return false;
    }

    // 检查今天是否已经显示过
    const shownDates = getShownDates();
    const todayKey = `${currentYear}-${currentMonth}-${currentDate}`;

    const shouldShow = !shownDates.includes(todayKey);

    // 调试信息
    console.log("[AI Notice] Date check:", {
      currentDate: `${currentYear}-${currentMonth}-${currentDate}`,
      shownDates,
      shouldShow,
    });

    return shouldShow;
  } catch (error) {
    console.error("[AI Notice] Error checking if should show notice:", error);
    return false;
  }
};

/**
 * 标记今天已经显示过AI内容标识公告
 */
export const markAINoticeShown = (): void => {
  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  const currentDate = today.getDate();
  const currentYear = today.getFullYear();

  const todayKey = `${currentYear}-${currentMonth}-${currentDate}`;
  const shownDates = getShownDates();

  if (!shownDates.includes(todayKey)) {
    shownDates.push(todayKey);
    localStorage.setItem(AI_NOTICE_STORAGE_KEY, JSON.stringify(shownDates));
  }
};

/**
 * 获取已经显示过公告的日期列表
 */
const getShownDates = (): string[] => {
  try {
    const stored = localStorage.getItem(AI_NOTICE_STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.warn(
      "Failed to parse AI notice shown dates from localStorage:",
      error,
    );
    return [];
  }
};

/**
 * 清空已显示记录（测试用）
 */
export const clearAINoticeHistory = (): void => {
  localStorage.removeItem(AI_NOTICE_STORAGE_KEY);
  console.log("[AI Notice] History cleared");
};

/**
 * 强制显示弹窗（测试用）
 * 使用方法：在浏览器控制台运行 window.forceShowAINotice()
 */
export const forceShowAINotice = (): boolean => {
  console.log("[AI Notice] Force showing notice for testing");
  return true;
};

// 将测试函数暴露到全局，方便调试
if (typeof window !== "undefined") {
  (window as any).clearAINoticeHistory = clearAINoticeHistory;
  (window as any).forceShowAINotice = forceShowAINotice;
}
